<template>
  <div class="d-flex justify-center align-center" style="height: 100vh">
    <div class="container text-center py-5">
      <img
        class="brand"
        src="/images/ocularlogo.svg"
        style="width: 200px; height: 75.41px"
      >
      <h1>
        {{$t('info.title')}}
      </h1>

      <h3 class="font-weight-regular text-muted mb-5">
        {{$t('info.subtitle')}}
      </h3>

      <v-btn
        color="primary"
        href="https://ocularsolution.com"
        role="button"
        target="_blank"
        class="os-rounded"
      >
        {{$t('info.button')}}
      </v-btn>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Ocular extends Vue {}
</script>
